var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstaFooter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    fill: "none",
    viewBox: "0 0 42 43",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.7,
    d: "M21.169 41.341C32.122 41.341 41 32.461 41 21.508S32.121 1.676 21.17 1.676c-10.954 0-19.833 8.88-19.833 19.832 0 10.954 8.88 19.833 19.833 19.833Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.833 18.575a3.937 3.937 0 0 0-3.944 3.944 3.937 3.937 0 0 0 3.944 3.944 3.937 3.937 0 0 0 3.944-3.944 3.937 3.937 0 0 0-3.944-3.944m0 6.508a2.57 2.57 0 0 1-2.564-2.564 2.566 2.566 0 0 1 2.564-2.564 2.566 2.566 0 0 1 2.564 2.564 2.57 2.57 0 0 1-2.564 2.564m5.025-6.669c0 .511-.412.92-.92.92a.92.92 0 1 1 .92-.92m2.612.934c-.059-1.233-.34-2.324-1.243-3.223-.899-.9-1.99-1.181-3.223-1.243-1.27-.072-5.076-.072-6.346 0-1.229.059-2.32.34-3.223 1.24-.902.898-1.18 1.99-1.242 3.222-.072 1.27-.072 5.076 0 6.346.058 1.233.34 2.324 1.242 3.223.903.9 1.99 1.181 3.223 1.243 1.27.072 5.076.072 6.346 0 1.233-.059 2.324-.34 3.223-1.243.9-.899 1.181-1.99 1.243-3.223.072-1.27.072-5.073 0-6.342m-1.64 7.705a2.6 2.6 0 0 1-1.463 1.462c-1.012.402-3.415.31-4.534.31s-3.525.088-4.534-.31a2.6 2.6 0 0 1-1.462-1.462c-.402-1.012-.31-3.415-.31-4.534s-.088-3.525.31-4.534a2.6 2.6 0 0 1 1.462-1.462c1.012-.402 3.415-.31 4.534-.31s3.525-.088 4.534.31a2.6 2.6 0 0 1 1.462 1.462c.402 1.012.309 3.415.309 4.534s.093 3.525-.309 4.534"
  })));
};
export default SvgInstaFooter;